
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * axboot 오브젝트 axboot 애플리케이션을 편리하게 사용하기 위한 오브젝트 입니다.
 * @var {Object} axboot
 */
var axboot = {};

/**
 * axboot의 환경 변수 저장 공간
 * @type {Object} axboot.def
 * @example
 * ```js
 * axboot.def.menuHeight = 20;
 * // 와 같이 원하는 속성을 저장 / 사용 할 수 있다.
 * ```
 */
axboot.def = {
    'pageFunctionName' : 'fnObj',
    'iframeLoadingMsg' : '<i class="cqc-chequer ax-loading-icon lg"></i>',
    'dialogTitle'      : 'Info',
    'defaultPageSize'  : 25,    
    'dateMonthFormat'  : 'YYYY.MM',
    'dateFormat'       : 'YYYY.MM.DD',
    'dateTimeFormat'   : 'YYYY.MM.DD HH:mm:ss',
    'uploader'         : {
        'storageUrl'  : '/common/file/Storage.do',
        'uploadUrl'   : '/common/file/UploadFile.do',
        'fileListUrl' : '/common/file/UploadFileList.do',
        'deleteUrl'   : '/common/file/UploadFileDelete.do'
    }
};

/**
 * document ready 상태가 되었을 때 실행됩니다. 애플리케이션 초기화를 담당합니다.
 * @method axboot.init
 */
axboot.init = function () {
    axboot.pageAutoHeight.init();
    axboot.pageAutoHeight.align();

    setTimeout(function () {
        $('[data-ax5layout]').ax5layout({
            splitter: {
                size: 6
            },
            autoResize: false,
            onStateChanged: function onStateChanged() {},
            onResize: function onResize() {
                axboot.layoutResize();
            }
        }); // 레이아웃 플러그인 실행

        axboot.pageStart();

        var debounceFn = ax5.util.debounce(function (val) {
            axboot.pageResize();
            axboot.pageAutoHeight.align();
            $('[data-ax5layout]').ax5layout('reset');
        }, 20);

        $(window).resize(function () {
            debounceFn();
        });
        $(document.body).on('click', function () {
            if (window.parent != window) {
                $(parent.document.body).trigger("click");
            }
        });
    });
};

/**
 * axboot.def.pageFunctionName의 pageStart를 실행해 줍니다.
 * @method axboot.pageStart
 *
 */
axboot.pageStart = function () {
    if (window[axboot.def.pageFunctionName] && window[axboot.def.pageFunctionName].pageStart) {
        // 프레임 셋에 타이머 초기화.
        if (top.fnObj && top.fnObj.activityTimerView) {
            top.fnObj.activityTimerView.update();
        }
        window[axboot.def.pageFunctionName].pageStart();
    }
};
/**
 * axboot.def.pageFunctionName의 pageResize를 실행해 줍니다.
 * @method axboot.pageResize
 */
axboot.pageResize = function () {
    if (window[axboot.def.pageFunctionName] && window[axboot.def.pageFunctionName].pageResize) {
        window[axboot.def.pageFunctionName].pageResize();
    }
};

/**
 * 페이지내부에 선언된 ax5layout안에 UI들에 강제 resize이벤트 발생시켜 줌.
 * @method axboot.layoutResize
 */
axboot.layoutResize = function (_delay) {

    $('[data-fit-height-content]').each(function () {
        var $this = $(this);
        var _pHeight = $this.offsetParent().height();
        var name = this.getAttribute("data-fit-height-content");

        var _tabHeight = 0;

        // 20180514 (이상훈) : split-layout > tab layout 이 있을 경우 문제 해결 후 주석해제
        /*
        if (!ax5.util.isNothing($this.data('config'))) {
            var objConfig = ax5.util.parseJson($this.data('config'));

            if (!ax5.util.isNothing(objConfig) && objConfig['layout'] == 'tab-panel') {
                _tabHeight = 60;
            }
        }
        */

        var _asideHeight = 0;
        $('[data-fit-height-aside="' + name + '"]').each(function () {
            _asideHeight += $(this).outerHeight();
        });
        $this.css({ height: _pHeight - _asideHeight - _tabHeight });
    });
    
    $('[data-fix-height-content]').each(function () {
        var $this = $(this);
        var _pHeight = this.getAttribute("height");
        $this.css({ height: _pHeight });        
    });

    function fn() {
        if (ax5.ui.grid_instance) {
            var gi = ax5.ui.grid_instance.length;
            while (gi--) {
                ax5.ui.grid_instance[gi].setHeight(ax5.ui.grid_instance[gi].$target.height());
            }
        }
        if (ax5.ui.mask_instance) {
            var mi = ax5.ui.mask_instance.length;
            while (mi--) {
                ax5.ui.mask_instance[mi].align();
            }
        }
        if (ax5.ui.autocomplete_instance) {
            ax5.ui.autocomplete_instance.align();
        }
        if (ax5.ui.combobox_instance) {
            ax5.ui.combobox_instance.align();
        }
    }
    if (_delay) {
        setTimeout(function () {
            fn();
        }, _delay);
    } else {
        fn();
    }
};

/**
 * 페이지안에 [role="page-content"] 과 그 외의 부분의 높이를 계산하여 페이지 안에 컨텐츠의 높이들을 꽉 차게 해줍니다.
 * @Object {Object} axboot.pageAutoHeight
 */
axboot.pageAutoHeight = {
    /**
     * @method axboot.pageAutoHeight.init
     */
    init: function init() {
        this.active = $(document.body).attr("data-page-auto-height");
    },
    /**
     * @method axboot.pageAutoHeight.align
     */
    align: function align() {
        if (!this.active) return false;
        // page-content-auto-height
        (function () {
            var winHeight = $(window).height();
            var minusHeight = 0;
            $('[role^="page-"]').each(function () {
                var sectionName = this.getAttribute("role");
                if (sectionName != "page-content") {
                    minusHeight += $(this).outerHeight();
                }
            });
            var contentHeight = winHeight - minusHeight - 10;
            $('[role="page-content"]').css({ height: contentHeight });
        })();
    }
};

///// ~~~~~~~~~~~~~~~~~~~~~~
$(document.body).ready(function () {
    axboot.preparePlugin.pageStart();
    axboot.init();

    document.createElement("lang");
});

window.onError = function () {
    window.CollectGarbage && window.CollectGarbage();
};

window.onUnload = function () {
    window.CollectGarbage && window.CollectGarbage();
};